import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';

@Injectable()
export class StateEasyrouteEffects {
    constructor(private actions$: Actions) {}
}
